import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement, ISelectFieldSingleItem } from '../Form/DynamicForm'
import { InputLabel, MenuItem, Select } from '@mui/material'
import { updateAllLocations, useReturnAllLocations } from '../../features/locations/locationsSlice'
import LocationsApp, { ILocationModel } from '../../features/locations/LocationsApp'
import Countries from '../../features/locations/Countrries'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { updateAllWarehouses, useReturnAllWarehouses } from '../../features/warehouses/warehousesSlice'
import WarehousesApp, { IWarehouseModel } from '../../features/warehouses/WarehousesApp'
import { updateAllSections, useReturnAllSections } from '../../features/sections/sectionsSlice'
import SectionsApp, { ISectionModel } from '../../features/sections/SectionsApp'
import { ISearchParam } from '../../features/BaseApp'

export default function SectionSelectFieldElement(props: IBaseDynamicFormElement) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, handleOnChange, data, addNoneItem, searchParams, disabled } = props

    const [saveSearchParams, setSaveSearchParams] = useState<ISearchParam[]>([])

    const items = useReturnAllSections()
    const sectionsApp = new SectionsApp()

    const [value, setValue] = useState<any>("")

    const labelId = "label_of_" + id

    const renderItems = () => {

        if (items && items.length > 0){
            return items.map((item: ISectionModel, index: number) => <MenuItem value={item.id} key={index}>{item.title}</MenuItem>)
        }
        
        return <></>
    }

    const areArraysEqual = (arr1: ISearchParam[], arr2: ISearchParam[]) => {
            // Check if lengths are the same
            if (arr1.length !== arr2.length) {
                return false;
            }

            // Create frequency maps
            const countOccurrences = (arr: ISearchParam[]): Record<string, number> =>
                arr.reduce((acc, val) => {
                    const key = JSON.stringify(val); // Handle objects as keys
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {} as Record<string, number>);

            const freq1 = countOccurrences(arr1);
            const freq2 = countOccurrences(arr2);

            // Compare frequency maps
            for (const key in freq1) {
                if (freq1[key] !== freq2[key]) {
                    return false;
                }
            }
            return true;
    }

    useEffect(() => {
        setValue(data.value)
    }, [data.value])

    const loadItems = () => {

        if (searchParams && searchParams.length > 0){
            setSaveSearchParams(searchParams)
        }

        sectionsApp.listOfInstances(1, "", true, false, searchParams)
        .then(response => {

            const data = response.data
            dispatch(updateAllSections(data))

        })
        .catch(error => {
            handleRequestError(error, dispatch)
        })
    }

    useEffect(() => {
        loadItems()
    }, [])

    useEffect(() => {
        console.log(searchParams, saveSearchParams, areArraysEqual(searchParams ? searchParams : [], saveSearchParams))
        if (searchParams && !areArraysEqual(searchParams, saveSearchParams)){
            loadItems()
        }
    }, [searchParams])

    return(
        <>
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    labelId={labelId}
                    id={id}
                    value={value}
                    label={label}
                    name={id}
                    onChange={(e) => handleOnChange(id, e.target.value)}
                    error={data.helperTextType === "error" ? true : false}
                    disabled={disabled ? disabled : data.disabled}
                    fullWidth={fullWidth}
                >
                    {addNoneItem && <MenuItem value="">None</MenuItem>}
                    {renderItems()}
                </Select>
        </>
    )
}